import React from 'react';
import { Link } from 'react-router-dom';

const CustomLink = ({ name, url, isActive }) => {
  return (
    <Link
      to={url}
      className={`p-2 rounded-md transition-colors duration-300 ${isActive ? 'text-[#f4742f] md:bg-[#fffffff9]' : 'text-[white] md:bg-[#f8eded2d] hover:text-[#ffebc7]'}`}
    >
      {name}
    </Link>
  );
};

export default CustomLink;
